"use client"

// Centralized registry for determining which filters are applicable on which pages.
// Extend this file as new filters or pages are added.

type FilterKey = "relayers"

// Precompile regex at the module top level for performance.
const GLOBAL_TOKEN_ACTIVITY_PATH_RE =
  /(\/activity)(?:\/[^/]+){0,2}\/tokens(?:\/|$)/

function isGlobalTokenActivityPath(pathname: string): boolean {
  // Match any of:
  // - /activity/tokens
  // - /activity/<segment>/tokens
  // - /activity/<segment>/<segment>/tokens
  // Using a bounded pattern avoids accidental matches on unrelated paths.
  return GLOBAL_TOKEN_ACTIVITY_PATH_RE.test(pathname)
}

export function isFilterApplicable(
  filter: FilterKey,
  pathname: string,
): boolean {
  switch (filter) {
    case "relayers":
      return isGlobalTokenActivityPath(pathname)
    default:
      return false
  }
}
